import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { fmtRM, fmtDate } from "../../lib/format";
import { PageTitle, StatusBadge, Spinner } from "../../components/Shell";

export default function Statements() {
  const [fees, setFees] = useState(null);
  const [receipts, setReceipts] = useState(null);

  useEffect(() => {
    api.get("/portal/fees").then((r) => setFees(r.data.fees)).catch(() => {});
    api.get("/portal/receipts").then((r) => setReceipts(r.data.payments)).catch(() => {});
  }, []);

  if (!fees || !receipts) return <Spinner />;

  return (
    <div data-testid="portal-statements" className="max-w-4xl mx-auto">
      <PageTitle title="Yuran & Resit" sub="Penyata yuran dan resit bayaran anda" />
      <div className="bg-card rounded-xl border border-brand-deep/10 overflow-hidden mb-6">
        <div className="px-5 py-4 border-b border-brand-deep/10 font-display font-semibold text-brand-dark">Yuran</div>
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-brand-deep/5 text-left text-xs uppercase tracking-wider text-muted-foreground">
              <th className="px-5 py-2.5">Jenis</th><th className="px-5 py-2.5">Tempoh</th><th className="px-5 py-2.5 text-right">Amaun</th><th className="px-5 py-2.5">Status</th>
            </tr>
          </thead>
          <tbody>
            {fees.map((f) => (
              <tr key={f.fee_id} className="border-b border-brand-deep/5" data-testid={`portal-fee-row-${f.fee_id.slice(-6)}`}>
                <td className="px-5 py-3 font-medium text-brand-dark">{f.fee_type}</td>
                <td className="px-5 py-3 text-xs font-mono">{f.period || "-"}</td>
                <td className="px-5 py-3 text-right font-mono">{fmtRM(f.amount)}</td>
                <td className="px-5 py-3"><StatusBadge status={f.status} /></td>
              </tr>
            ))}
            {fees.length === 0 && <tr><td colSpan={4} className="px-5 py-8 text-center text-sm text-muted-foreground">Tiada yuran.</td></tr>}
          </tbody>
        </table>
      </div>
      <div className="bg-card rounded-xl border border-brand-deep/10 overflow-hidden">
        <div className="px-5 py-4 border-b border-brand-deep/10 font-display font-semibold text-brand-dark">Resit Bayaran</div>
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-brand-deep/5 text-left text-xs uppercase tracking-wider text-muted-foreground">
              <th className="px-5 py-2.5">No. Resit</th><th className="px-5 py-2.5">Tarikh</th><th className="px-5 py-2.5">Kaedah</th><th className="px-5 py-2.5 text-right">Amaun</th>
            </tr>
          </thead>
          <tbody>
            {receipts.map((p) => (
              <tr key={p.payment_id} className="border-b border-brand-deep/5" data-testid={`portal-receipt-row-${p.receipt_no}`}>
                <td className="px-5 py-3 font-mono text-xs font-bold text-brand-deep">{p.receipt_no}</td>
                <td className="px-5 py-3 text-xs">{fmtDate(p.paid_at)}</td>
                <td className="px-5 py-3 text-xs">{p.method}</td>
                <td className="px-5 py-3 text-right font-mono font-semibold">{fmtRM(p.amount)}</td>
              </tr>
            ))}
            {receipts.length === 0 && <tr><td colSpan={4} className="px-5 py-8 text-center text-sm text-muted-foreground">Tiada resit.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
